import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomButton from '../../buttonComponent/CustomButton';
import { AddCircleOutlinedIcon } from '../../icons';
import { NavigationConfig } from '../../../utils/navigation_config';
import PermissionGuard from '../../../core/PermissionGuard';
import StartApplicationDialog from './StartApplicationDialog';
var CreateApplicationButton = function () {
    var navigate = useNavigate();
    var _a = useState(false), isStartApplicationOpen = _a[0], setIsStartApplicationOpen = _a[1];
    var handleStartApplication = useCallback(function (selection) {
        setIsStartApplicationOpen(false);
        navigate(NavigationConfig.CreateApplication, { state: selection });
    }, [navigate]);
    return (React.createElement(PermissionGuard, { requiredPermission: "APPLICATION_MANAGMENT", requiredAccess: "Add" },
        React.createElement(CustomButton, { MDButton: true, variant: "contained", startIcon: React.createElement(AddCircleOutlinedIcon, null), onClick: function () { return setIsStartApplicationOpen(true); }, fullWidth: false, iconSize: 18 }, "New Application"),
        React.createElement(StartApplicationDialog, { open: isStartApplicationOpen, onClose: function () { return setIsStartApplicationOpen(false); }, onStart: handleStartApplication })));
};
export default CreateApplicationButton;
